"use client";

import { useState } from "react";
import AuthorModal from "components/AuthorModal";
import styles from "./page.module.css";

export default function NewsInteractions({ author, children }) {
  const [showAuthorModal, setShowAuthorModal] = useState(false);

  return (
    <>
      {author && (
        <div className={styles.header}>
          <div className={styles.authorSection}>
            <div
              className={styles.authorClickable}
              onClick={() => setShowAuthorModal(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setShowAuthorModal(true)}
            >
              {children}
            </div>
          </div>
        </div>
      )}

      <AuthorModal
        author={author}
        open={showAuthorModal}
        onClose={() => setShowAuthorModal(false)}
      />
    </>
  );
}
